import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualUsuarios from '../../actions/usuario/determinarPaginaAtualUsuarios'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoUsuarios extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualUsuarios}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualUsuario,
    total: state.usuarios.total,
    registrosPorPagina: state.registrosPorPaginaUsuario
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualUsuarios }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoUsuarios)
